import { Component } from 'san';
import * as $ from 'jquery';
import * as moment from 'moment';

import DatePicker from '../DatePicker/DatePicker';
import LeanInputCell from '../LeanInputCell/LeanInputCell';

export default class LeanDatePicker extends Component {
    static components = {
        'ui-lean-input-cell': LeanInputCell,
        'ui-date-picker': DatePicker,
    };

    constructor(options: any) {
        super(options);
    }

    initData(): {
        focusId: string;    // {{}} 当前focus的组件的id，用来高亮组件
        id: string; // {{}}
        title: string;  // {{}}
        value: string;   // {==}
        isRequired: boolean;    // {{}}
        mode: 'input' | 'picker';  // 展示形式
    } {
        return {
            focusId: null,
            id: null,
            title: '',
            value: null,
            isRequired: false,
            mode: 'input'
        };
    }

    inited(): void {
        this.watch('value', value => {
            const regExp = new RegExp("[^0-9\\-]", 'ig');   // 数字、横线
            let formatValue = value.replace(regExp, '');
            this.data.set('value', formatValue);

            const isValid = moment(formatValue, 'YYYY-MM-DD').isValid();    // 注意：'2022-01-01'、 '2022-01-01 abc'、'-12-', isValid() 的值都是true
            if (!isValid) {
                // 处理：想输入'2022-01-01'，刚输到‘2022-0’ isValid = false
                const lastChar = formatValue.slice(-1);
                if ('0' === lastChar) {
                    return;
                }
                // 不合法，就删除最后一个字符
                formatValue = formatValue.slice(0, formatValue.length - 1);
                this.data.set('value', formatValue);
            } else if (value !== formatValue) {
                this.data.set('value', formatValue);
            }
        });
    }

    onFocus() {
        this.focusToInput();
    }

    onBlur() {
        this.rectifyValue();
        this.fire('blur', this.data.get('id'));
    }

    onClick() {
        this.focusToInput();
        this.fire('focus', this.data.get('id'));
    }

    onIconClick() {
        this.focusToDatePicker();
    }

    /*private*/focusToInput() {
        this.data.set('mode', 'input');
        $(this.ref('dateInput')).focus();
    }

    /*private*/focusToDatePicker() {
        this.data.set('mode', 'picker');
        if (!this.data.get('value')) {
            const today = moment().format('YYYY-MM-DD');
            this.data.set('value', today)
        }
        this.nextTick(() => {
            const datePicker = this.ref('datePicker');
            $(datePicker.el).find('input').focus();
        });

    }

    onDatePickerValueChange() {
        this.focusToInput();
    }

    fireValueChange(value: string) {
        this.fire('value-change', value);
    }

    rectifyValue() {
        // 修正 '2022-01-01 abc'、'-12-' 等
        let value = this.data.get('value');
        if (value) {
            value = moment(value).format('YYYY-MM-DD');
        }
        this.data.set('value', value);
    }

}
